import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service, Controller} from "angular-ecmascript/module-helpers";

export var Name = '$modalDelegate';

export class ModalController extends Controller {

    constructor($scope) {
        super(...arguments);

        this.$scope.$on('modal.show', (event, data)=> {
            this.onShow(data);
        });
    }

    onShow(args) {

    }

    save(result) {
        this.$scope.$emit('modal.save', result);
    }

    cancel(result) {
        this.$scope.$emit('modal.cancel', result);
    }
}

export class ModalDelegate extends Service {
    static $name = Name;
    static $inject = ['$q', '$rootScope', '$ionicModal', '$timeout'];

    show(options) {
        var defer = this.$q.defer();
        var modalView = null;

        if (options == null) {
            options = {};
        }

        if (options.animation == null) {
            options.animation = 'slide-in-up'
        }

        if (options.hideDelay == null) {
            options.hideDelay = 920;
        }

        options.scope = this.$rootScope.$new(true, options.scope);
        options.scope.$args = options.args;

        options.scope.$cancel = (result)=> {
            options.scope.$emit('modal.cancel', result);
        };

        options.scope.$save = (result)=> {
            options.scope.$emit('modal.save', result);
        };

        var modalControllerPromise;
        if (options.templateUrl) {
            modalControllerPromise = this.$ionicModal.fromTemplateUrl(options.templateUrl, options);

        } else if (options.template) {
            modalControllerPromise = this.$q.when(this.$ionicModal.fromTemplate(options.template, options));

        } else {
            throw "No template or templateUrl option specified.";
        }

        modalControllerPromise.then(function (modal) {
            modalView = modal;
            options.scope.$broadcast('modal.show', options.args);
            modalView.show();
        });

        options.scope.$on('modal.save', function (event, result) {
            event.stopPropagation();
            closeModal(event, result, options.onSave);
        });

        options.scope.$on('modal.cancel', function (event, result) {
            event.stopPropagation();
            closeModal(event, result, options.onCancel);
        });

        var self = this;
        var closeInProgress = false;

        function closeModal(event, result, callback) {
            if (closeInProgress) {
                return;
            }

            closeInProgress = true;

            var callbackPromise = self.$q.when(null);
            if (callback && (typeof callback == 'function')) {
                callbackPromise = self.$q.when(callback(result));
            }

            callbackPromise.then(function () {
                modalView.hide().then(() => {
                    self.$timeout(()=> {
                        modalView.remove();
                    }, options.hideDelay);
                });

                defer.resolve(result);
            });
        }

        return defer.promise;
    }
}

var ModalDelegateModule = Angular.module('modal-delegate', []);

new Loader(ModalDelegateModule)
    .load(ModalDelegate)
    .load(ModalController);

export default ModalDelegateModule;



// WEBPACK FOOTER //
// ./src/modules/core/views/modal-delegate.service.js